export { AboutCookieModal } from './ui/AboutCookieModal/AboutCookieModal';
export { AcceptCookieModal } from './ui/AcceptCookieModal/AcceptCookieModal';
export { cookieModalReducer, openAboutCookieModal, openAcceptCookieModal } from './model/slice/cookieModalSlice';
